<template>
  <v-row>
    <v-col cols="12"
           class="text-body-2 py-0">
      <p>
        Before using the Electronic Payment System, please review these Terms & Conditions which constitute
        an agreement between you and Texas Farm Bureau Mutual Insurance Company, Texas Farm Bureau Premium
        Finance Company, Texas Farm Bureau Underwriters Texas Farm Bureau Casualty Insurance Company, and
        Farm Bureau County Mutual Insurance Company of Texas (&ldquo;we&rdquo;, &ldquo;our&rdquo;, &ldquo;us&rdquo;, &ldquo;the Companies&rdquo;) and describe
        both the benefits and restrictions on using this service to pay your insurance premiums. Please print
        and retain for future reference. These Terms & Conditions may be updated from time to time.
      </p>
      <p>
        Your premium payment will be deducted from your checking account. One time transfers are available online through this site.
        <u>Automatic recurring payments are not currently available.</u>
        You can use a valid checking account from any recognized financial institution (bank, securities firm, etc.) in the country.
        Check with your financial institution to make sure it accepts electronic debits from the account you choose and to determine
        if your financial institution will charge you any fees for this service. Since some financial institutions use unique bank
        routing numbers and account numbers for electronic payments, it would be a good idea to verify your routing number and
        account number with your financial institution before initiating a transaction. Each time you initiate a transaction,
        you authorize us or our agent to draw a check, draft or automated clearing house (ACH) debit in your name on your account.
        This amount will be payable to us or our agent in the amount of the transaction and be deemed as a payment to us. We will
        present this check, draft or ACH to your financial institution for immediate payment. We reserve the right to stop any ACH
        transaction based upon a previous return from your financial institution, which includes, but is not limited to, invalid
        bank account, account closed or unauthorized transactions.
      </p>
      <p>
        You acknowledge that the Companies reserve the right to terminate your use of online payments at any time and for any reason.
        You agree that by no means will you attempt to gain unauthorized access to this site, other accounts, computer systems or
        networks connected to the hosting server. You agree to notify the Companies immediately of any unauthorized use of your
        account or any other breach of security. You agree that you will not deface, alter or interfere with the pages on this
        web site or the underlying software code, nor will you engage in any activity that will cause disruption of service to any
        member or interfere with a member&rsquo;s use of this site. You agree to choose a password when registering. You are responsible
        for the confidentiality of your password and account information. You are fully responsible for all activities that occur
        using your password and account information. The Companies will not be liable for any loss that you may incur as a result
        of someone else using your password or account information, either with or without your knowledge. Also, you may not use
        anyone else&rsquo;s password at any time. You agree not to use the Electronic Payment System and service for illegal purposes
        or for the transmission of material that is unlawful, harassing, libelous (untrue and damaging to others), invasive of
        another&rsquo;s privacy, abusive, threatening or obscene, or that infringes the rights of other.
      </p>
      <p>
        If you agree to the terms and conditions as stated above, please enter your membership number and
        click &ldquo;Submit&rdquo;. If you do not agree or do not wish to proceed, please click &ldquo;Cancel&rdquo;.
      </p>
    </v-col>
  </v-row>
</template>
<script>
  export default {
    name: 'PFTermsConditions',
  };
</script>
<style lang="scss">

</style>
